export const environment = {
  production: false,
  // production: true,
  isLiveProduction: false,
  // BASE_URL: 'https://api-dlcm.mtn.ng',
  BASE_URL: 'https://dlcmapi.orlitstaging.net',
  // BASE_URL: 'https://api-dlcm-uat.mtn.ng',
  // BASE_URL: 'https://mydlcm-uat.mtn.ng',
  // BASE_URL: 'http://172.30.149.68:81',
  // BASE_URL: 'http://localhost:5122',
  Tenant: 'MTNNG',

  RecaptchaKey: '6LdecEMrAAAAAEJFrYDob92dmp8SVCyZOqdJent_',
  DXR:'MIIBCgKCAQEAubPV1mBQtlg/Pp+eIEkxgWyqUtybW0nRsVRAOrMTHSRcTebkou4W\npbRl+uf/m/hWOunAkWM7sOyTcFIyH17JKf5KZF7+RwHwmp31LgoKkhj2+BvfwXfX\neCP9+CVdM9QKz3yIMoDcoCOjGRXWsstob/5tAvncL97Dd0vdyD3HxgJLuk8oAS97\nlBkFSJQwLlU3buE0pvm6P12cruviXQMdR8NzutRT4Rjd/X8dyWVcKuNQ+HnQUcrf\n4JAwXaTPzjVM52vVXQf2NZdzkNQrgFVLFRLpVLdCC5tG9bnciPWdzvy/fAi3IGMW\nCBhkmJ3fyIF660XDe/RGrVv2cMx9mmYeUwIDAQAB',
};
